module.exports = __webpack_public_path__ + "img/italy-respiratory-diseases-female.e211dcb5.png";